

































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import FitOption from './FitOption.vue';
import { SEARCH } from '../config';
import SearchStore from '../../../../store/SearchStore';
@Component({
    components: {
        FitOption
    }
})
export default class FilterBox extends Vue {
    @Prop()
    isFilter: boolean;
    activeId!: any;
    isAct: boolean = true;
    isError: boolean = false;
    dataSource!: any[];
    backupdataSource!: any[];
    notice: number = Date.now();
    addButton!: HTMLElement;
    configSource!: any[];
    backupConfig!: any[];
    keyMap: { [key: string]: number } = {};
    searchData: any = SearchStore.state;
    styleObject: any = {
        top: '246px',
        left: '88px'
    };
    @Watch('searchData.searchItem')
    upSearch() {
        this.onReset();
    }
    @Watch('isFilter')
    onShow(bool: boolean) {
        if (bool) {
            this.activeId();
            this.configSource = this.copySource(this.backupConfig);
            this.dataSource = this.copySource(this.backupdataSource);
            // 打开筛选框备份数据
            this.isAct = true;
        }
    }
    copySource(data: any) {
        return JSON.parse(JSON.stringify(data));
    }
    onReset() {
        this.configSource = this.copySource(SEARCH);
        this.backupConfig = this.copySource(SEARCH);
        this.dataSource = [];
        this.backupdataSource = [];
        this.configSource.forEach((vo: any, index: number) => {
            const keys: string[] = vo.keys;
            keys.forEach((key: string) => {
                this.keyMap[key] = index;
            });
        });
    }
    rollback(key: string) {
        const index: number = this.keyMap[key];
        this.configSource[index] = JSON.parse(JSON.stringify(SEARCH[index]));
    }
    onDelete(ev: any) {
        for (let i = this.dataSource.length - 1; i > -1; i--) {
            const vo = this.dataSource[i];
            if (vo.key === ev.key) {
                if (vo.querys) {
                    this.rollback(vo.querys.attribute);
                }
                this.dataSource.splice(i, 1);
                this.onKchange(ev);
                break;
            }
        }
    }
    onKchange(ev: any) {
        this.onChange(ev);
        this.notice = Date.now();
    }
    onChange(ev: any) {
        this.isAct = true;
        this.isError = false;
        for (let i = 0; i < this.dataSource.length; i++) {
            const vo = this.dataSource[i];
            if (vo.key === ev.key) {
                const data: any = ev.value;
                const index: number = this.keyMap[data.attribute];
                data.type = this.configSource[index].type;
                if (this.isWorking(data.attribute)) {// 存在已经被序列化
                    data.working = false;
                }
                vo.querys = data;
            }
            if (!vo.querys) {
                this.isAct = false;
            }
        }
    }
    addClick() {
        if (this.isAct) {
            this.isAct = false;
            this.dataSource.push({ key: Date.now(), querys: null });
        }
    }
    isWorking(attribute: string) {
        const index: number = this.keyMap[attribute];
        const config: any = this.configSource[index];
        if (config.working) {// 存在已经被序列化
            return true;
        }
        return false;
    }
    clickNo() {
        // 取消还原备份数据
        this.isError = false;
        // this.configSource = this.copySource(this.backupConfig);
        // this.dataSource = this.copySource(this.backupdataSource);
        this.notice = Date.now();
        this.$emit('close', { type: 'NO' });
    }
    clickYes() {
        const data = [];
        this.dataSource.forEach((vo: any) => {
            const querys = vo.querys;
            if (!querys) {
                this.isError = true;
            } else {
                if (!querys.working && this.isWorking(querys.attribute)) {// 存在已经被序列化
                    const json = JSON.parse(querys.value);
                    querys.attribute = json.attribute;
                    querys.value = json.value;
                    querys.working = true;
                }
                data.push(querys);
            }
        });
        if (this.isAct) {
            this.backupConfig = this.copySource(this.configSource);
            this.backupdataSource = this.copySource(this.dataSource);
            this.$emit('close', { type: 'YES', data });
        } else {
            this.isError = true;
        }
    }
    mounted() {
        this.addButton = this.$refs.addButton as HTMLElement;
        this.activeId();
    }
    created() {
        this.onReset();
        this.activeId = () => {
            const btn: HTMLElement = document.querySelector('#configbtn');
            const rect: ClientRect = btn.getBoundingClientRect();
            this.styleObject.top = `${rect.top + 70}px`;
            this.styleObject.left = `${rect.left - 450}px`;
        };
        (window as any).addEventListener('resize', this.activeId);
    }
    beforeDestroy() {
        this.configSource = null;
        this.backupConfig = null;
        this.keyMap = null;
        (window as any).removeEventListener('resize', this.activeId);
    }
}
